import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { companiesAPI, settingsAPI } from '../services/api';
import { useAuth } from './AuthContext';
import { sessionGeneration } from '../services/session';

const Context = createContext(null);

export function CompaniesProvider({ children }) {
  const { isAuthenticated } = useAuth();
  const [companies, setCompanies] = useState([]);
  const [employeeFields, setEmployeeFields] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const refresh = useCallback(async () => {
    if (!isAuthenticated) return;
    setLoading(true);
    const generation = sessionGeneration();
    try {
      const [directory, fields] = await Promise.all([companiesAPI.getAll(), settingsAPI.getEmployeeFields()]);
      if (generation !== sessionGeneration()) return;
      setCompanies(directory.data);
      setEmployeeFields(fields.data);
      setError('');
    } catch (err) {
      setError('Could not load companies. Please retry.');
    } finally { setLoading(false); }
  }, [isAuthenticated]);
  useEffect(() => {
    if (isAuthenticated) refresh();
    else { setCompanies([]); setEmployeeFields([]); }
  }, [isAuthenticated, refresh]);
  const value = useMemo(() => ({ companies, employeeFields, error, loading, refresh,
    companyMap: Object.fromEntries(companies.map(c => [c.id, c])),
  }), [companies, employeeFields, error, loading, refresh]);
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export function useCompanies() { return useContext(Context); }
